/**
 * @fileoverview Serviço responsável por manter compatibilidade legada para acesso ao SocketManager.
 */

import { SocketManager } from "../context/Socket/SocketContext";

/**
 * Wrapper para compatibilidade com código legado que usa openSocket()
 *
 * Este arquivo estava sendo importado mas não existia no repositório,
 * causando falhas intermitentes na conexão socket da TicketsList.
 *
 * IMPORTANTE: Este é um wrapper de compatibilidade. Novos componentes
 * devem usar SocketContext diretamente via useContext.
 */
export default function openSocket() {
  // Obter companyId do localStorage (padrão usado pelo app)
  const companyId = localStorage.getItem("companyId");

  if (!companyId) {
    console.warn("[socket-io] companyId não encontrado no localStorage");
  }

  return SocketManager.getSocket(companyId);
}
